import React from 'react';
const IconStatusPaused = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 5H7V19H10V5Z" fill="#2D2E2E"/>
<path d="M17 5H14V19H17V5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconStatusPaused;